import React, { useContext } from "react";
import WorkflowContext from "../contexts/WorkflowContext";

function useWorkflowContext() {
    const context = useContext(WorkflowContext);
    return context;
}

export default useWorkflowContext;
